import { DeleteIcon } from '@vlabs/icons';
import { Button } from '@vlabs/uikit/components/controls/button';
import type { ButtonProps } from '@vlabs/uikit/components/controls/button';
import type { WithDataTestid } from '@vlabs/uikit/types';
import { useTranslation } from 'react-i18next';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import type { DeletePermissionTagsProps } from '../types';
import { useDeletePermissionTags } from './useDeletePermissionTags';

type DeletePermissionTagsButtonProps = DeletePermissionTagsProps & WithDataTestid & ButtonProps;

const displayName = 'DeletePermissionTagsButton';
const testid = buildTestid(displayName);

function DeletePermissionTagsButton({
  permissionTags: permissionTagsIds,
  onDeletePermissionTags = undefined,
  'data-testid': dataTestId = undefined,
  ...props
}: DeletePermissionTagsButtonProps): JSX.Element {
  const { t } = useTranslation();
  const deletePermissionTags = useDeletePermissionTags({ permissionTags: permissionTagsIds });

  return (
    <Button
      icon={<DeleteIcon />}
      kind="negative"
      onClick={async () => {
        await deletePermissionTags();
        onDeletePermissionTags?.();
      }}
      {...testid(dataTestId)}
      {...props}
    >
      {t('features:delete_permission_tags.buttons.delete')}
    </Button>
  );
}

DeletePermissionTagsButton.displayName = displayName;

export { DeletePermissionTagsButton };
